import classNames from 'classnames'
import VIPBadge from 'components/ChatHeader/VIPBadge'
import { Avatar, Icon, T, Time } from 'components/misc'
import AvatarStatusBubble from 'components/misc/AvatarStatusBuble'
import { MODES } from 'core/constants'
import { maxBy } from 'lodash'
import { inject, observer } from 'mobx-react'
import React from 'react'
@inject('actions', 'store')
@observer
class ChatList extends React.Component {
  state = {
    minimizedLimit: 1,
  }

  openConversation = conversation => {
    const { actions } = this.props
    actions.chat.setUserConversation(conversation.conversationUid)
    actions.chat.readConversation(conversation)
    conversation.unreadByMeCount = 0
    if (!this.props.isOpen) {
      this.props.toggleOpen?.()
    }
  }

  componentDidMount() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  onResize = () => {
    this.setState({
      minimizedLimit: Math.floor((window.innerHeight - 120) / 45),
    })
  }

  prepareList = () => {
    let { visibleConversations: conversations, conversation, filteredConversationList } = this.props.store
    if (this.props.isOpen) {
      conversations = conversations.filter(c => c.conversationUid != conversation.conversationUid)
    }
    if (this.props.options.mode === MODES.CHAT_LIST) {
      return filteredConversationList.map(c => ({
        id: c.conversationUid,
        profile: c.otherUserProfile,
        conversation: c,
        lastMessage: maxBy(c.messages, m => m.sentAt),
        unreadByMeCount: c.unreadByMeCount,
      })).sort((x, y) => (y?.lastMessage?.sentAt || 0) - (x?.lastMessage?.sentAt || 0))
    }
    return conversations.map(c => ({
      id: c.conversationUid,
      profile: c.otherUserProfile,
      conversation: c,
      lastMessage: maxBy(c.messages.filter(m => m.type == 'message' && c.meIndex != m.sentBy), m => m.sentAt),
      unreadByMeCount: c.unreadByMeCount,
    }))
  }

  renderLastMessage = lastMessage => {
    let renderedMessage = '';
    switch (lastMessage.type) {
      case 'sexicon':
        renderedMessage =  'sent a sexicon'
        break;
      case 'gift':
      case 'giftReveal':
        renderedMessage =  'sent a gift'
        break;
      case 'image':
        renderedMessage =  'sent a photo'
        break;
      default:
        renderedMessage = lastMessage.message;
        break;
    }
    return lastMessage.sentBy === 1 ? 'You: ' + renderedMessage : renderedMessage
  }

  chatListModeRender = (list, limit) => {
    const { className } = this.props
    const { features } = this.props.options;
    return (
      <div className={`chat-list ${this.props.options.mode}-mode ${className}`}>
        <div className="content">
          {list.slice(0, limit).map(item => (
            <div className="list-item" key={item.id} onClick={() => this.openConversation(item.conversation)}>
              <div className="content-container">
                <div className="avatar-container">
                  <AvatarStatusBubble isOnline={item.profile.isOnline}>
                    <Avatar user={item.profile}/>
                  </AvatarStatusBubble>
                </div>
                <div className="text-container">
                  <div className="username">{item.profile.username} {item.profile.isFeatured && features.featuredFunctionality && <span><VIPBadge/></span>}</div>
                  <div className={`message ${item.lastMessage?.hidden ? 'blurred' : ''}`}>
                    {item.lastMessage && this.renderLastMessage(item.lastMessage)}
                </div>
                </div>
              </div>
              <div className={classNames('chat-list-time', { unread: item.unreadByMeCount })}>{item.lastMessage && <Time since={item.lastMessage.sentAt}/>}
                {item.unreadByMeCount > 0 && <span className="unread-number">{item.unreadByMeCount}</span>}
              </div>
            </div>
          ))}
          {list.length === 0 &&
            <div className="list-item">
              <div className="no-matches-text">No matches found in your search</div>
            </div>
          }
        </div>
      </div>
    )
  }
  render() {
    const { isOpen, toggleOpen, store, options } = this.props
    const count = store.conversations.length
    const unreadConversationsCount = store.conversations.filter(e => e.unreadByMeCount).length
    const list = this.prepareList()
    const limit = isOpen ? list.length : this.state.minimizedLimit
    const hiddenCount = list.length - limit

    if (options.mode === MODES.CHAT_LIST) {
      return this.chatListModeRender(list, limit)
    }
    return (
      <div className="chat-list">
        <header className="chat-list-header" {...(!isOpen && { onClick: toggleOpen })}>
          <div className="chat-list-unread">
            {unreadConversationsCount ? <div className="chat-list-unread-text">{unreadConversationsCount}</div> : null}
            <Icon iconName="chat" className="chat-list-unread-icon"/>
          </div>
          <div className="chat-list-title">{count} <T>conversations</T></div>
          <div className="chat-list-close">
            <div className="chat-list-close-button" onClick={toggleOpen}>
              <T>close</T>
              <Icon iconName="arrowUp" className="chat-list-close-icon"/>
            </div>
          </div>
        </header>
        <div className="chat-list-content">
          {list.slice(0, limit).map(item => (
            <div className="chat-list-item" key={item.id} onClick={() => this.openConversation(item.conversation)}>
              <Avatar user={item.profile}/>
              <div className="chat-list-username">{item.profile.username}</div>
              <div className="chat-list-time">{item.lastMessage && <Time since={item.lastMessage.sentAt}/>}</div>
              <div className="chat-list-message">{item.lastMessage && item.lastMessage.message}</div>
            </div>
          ))}
          {!isOpen && (
            <div className="chat-list-item chat-list-extra" onClick={toggleOpen}>
              {hiddenCount > 0 && <div className="chat-list-extra-count">+{hiddenCount}</div>}
              <Icon iconName="arrowUp" className="chat-list-open-icon"/>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default ChatList
